<div>
  <mat-sidenav-container class="layout">
    <mat-sidenav-content class="layout-content">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
